import { Container } from "react-bootstrap"
import { Outlet } from "react-router-dom"

import HeaderNoMenu from "../features/user/components/statuses/HeaderNoMenu"

const PaymentsLayout = () => {
  return (
    <>
      <HeaderNoMenu />
      <Container className="d-flex flex-column align-items-center text-center position-relative" style={{ paddingTop: "4.8375rem" }}>
        <Outlet />
      </Container>
    </>
  )
}
export default PaymentsLayout